import React from 'react';
import styled from 'styled-components';
import link from '../Utils/Format';

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    min-width: 120px;
`;

const SocialNetworksDisplay = (props) => {

    const formatTwitter = (twitter) => {
        if(!twitter) return null;
        if(twitter.includes("twitter.com")) return link(twitter);
        return "https://twitter.com/" + twitter.replace('@','');
    }


    const formatInstagram = (instagram) => {
        if(!instagram) return null;
        if(instagram.includes("instagram.com")) return link(instagram);
        return "https://instagram.com/" + instagram.replace('@','');
    }

    return (
        <Container>
            {props.twitter && <>
                <a href={formatTwitter(props.twitter)} target="_blank" rel="noreferrer"><img style={{width:"20px"}} src="/img/twitter.png" alt=""/></a>
            </>}
            {props.instagram && <>
                <a href={formatInstagram(props.instagram)} target="_blank" rel="noreferrer"><img style={{width:"20px"}} src="/img/instagram.png" alt=""/></a>
            </>}
            {props.linkedin && <>
                <a href={link(props.linkedin)} target="_blank" rel="noreferrer"><img style={{width:"20px"}} src="/img/linkedin.png" alt=""/></a>
            </>}
        </Container>
    );
};

export default SocialNetworksDisplay;
